import Parse from "parse";

import { ScheduleDataObjectType } from "@opendash/schedule";
import type { Schedule_Step } from "./Schedule_Step";

type OD3_Source = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface Schedule_TemplateAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  color?: string;
  cron?: ScheduleDataObjectType;
  description?: string;
  enabled: boolean;
  notifyBeforeDue: number;
  sources: Parse.Relation<Schedule_Template, OD3_Source>;
  steps: Parse.Relation<Schedule_Template, Schedule_Step>;
  tenant?: OD3_Tenant;
  title?: string;
}

export class Schedule_Template extends Parse.Object<Schedule_TemplateAttributes> {
  static className: string = "OD3_Maintenance_Schedule_Template";

  constructor(data?: Partial<Schedule_TemplateAttributes>) {
    super(
      "OD3_Maintenance_Schedule_Template",
      data as Schedule_TemplateAttributes
    );
  }

  get color(): string | undefined {
    return super.get("color");
  }
  set color(value: string | undefined) {
    super.set("color", value);
  }
  get cron(): any | undefined {
    return super.get("cron");
  }
  set cron(value: any | undefined) {
    super.set("cron", value);
  }
  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get enabled(): boolean {
    return super.get("enabled");
  }
  set enabled(value: boolean) {
    super.set("enabled", value);
  }
  get notifyBeforeDue(): number {
    return super.get("notifyBeforeDue");
  }
  set notifyBeforeDue(value: number) {
    super.set("notifyBeforeDue", value);
  }
  get sources(): Parse.Relation<Schedule_Template, OD3_Source> {
    return super.relation("sources");
  }
  get steps(): Parse.Relation<Schedule_Template, Schedule_Step> {
    return super.relation("steps");
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
}

Parse.Object.registerSubclass(
  "OD3_Maintenance_Schedule_Template",
  Schedule_Template
);
